var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row no-data"},[_vm._v("没有相关数据")])
}
var staticRenderFns = []

export { render, staticRenderFns }